import type { Recipient } from 'types/list'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import api from '@disco/api/server'
import {
  REFERRAL_INVITE,
  REFERRAL_INVITE_ERROR,
  REFERRAL_INVITE_SUCCESS,
} from '@disco/constants/ActionTypes'
/**
 * Sends referral invitations to a list of recipients via email.
 * @param recipients - Array of recipients to send invitations to
 * @param message - Custom message to include in the referral invitation
 * @returns Thunk that sends invitations and tracks analytics on success/failure
 */
export function referralInvite(
  recipients: Recipient[],
  message: string,
): (dispatch: any) => Promise<unknown> {
  return (dispatch: (...args: Array<any>) => any) => {
    dispatch({
      type: REFERRAL_INVITE,
      recipients,
    })
    const emails = recipients
      .map(({ email }) => email)
      .filter(email => email !== null && email !== undefined)
    return api
      .emailReferralInvitation(emails, message)
      .then(result => {
        dispatch({
          type: REFERRAL_INVITE_SUCCESS,
        })
        dispatch(
          sendMixpanelEvent('Send referral', {
            'Recipients count': recipients.length,
          }),
        )
        return result
      })
      .catch(error => {
        dispatch({
          type: REFERRAL_INVITE_ERROR,
          error,
        })
        return error
      })
  }
}
